/* app/js/src/components/common/close-btn/close-btn.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  cursor: pointer;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  background: #f1f3f4 url(/assets/icons/x-close-pop.svg) no-repeat center;
  -webkit-background-size: 7px;
  background-size: 7px;
  position: absolute;
  top: -5px;
  right: -6px;
}
/*# sourceMappingURL=close-btn.css.map */
